<template>
	<div class="mainWrapper po">
		<h1>Warehouse Stock Transfer</h1>

		<div class="links">
			<b-button type="is-info"
				><router-link to="/warehouse/stock-transfer/create">
					Create Stock Transfer
				</router-link></b-button
			>

			<b-button type="is-info"
				><router-link to="/warehouse/stock-transfer/export">
					Export Stock Transfer
				</router-link></b-button
			>
		</div>

		<div class="general-search">
			<div>
				<b-field>
					<b-input v-model="searchPrductTransfer" placeholder="Transfer Search" @keyup.native.enter="searchTransfer()"></b-input>
				</b-field>
			</div>

			<div>
				<b-button type="is-info" @click="searchTransfer()" icon-left="magnify">Search</b-button>
			</div>
		</div>

		<div class="list" v-if="list">
			<div class="transferList header">
				<div>TRANSFER CODE</div>

				<div>AUTHOR</div>
				<div>CREATED DATE</div>

				<div></div>
			</div>

			<div v-for="(item, index) of list" v-bind:key="index" class="transferList">
				<div>{{ item.code }}</div>

				<div>
					{{ item.author.name }}
				</div>
				<div>{{ convertTime(item.createdAt) }}</div>
				<div @click="transferDetail(item._id)" class="hyperlink">
					<ios-arrow-forward-icon w="32px" h="32px" />
				</div>
			</div>

			<paginate
				v-model="page"
				:page-count="pageCount"
				:click-handler="pagerClick"
				:prev-text="'prev'"
				:next-text="'next'"
				:container-class="'pagination'"
			>
			</paginate>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PurchaseOrder',
	data: function() {
		return {
			limit: this.$config.pageItemsLimit, // For pager
			list: null, // Will contain all the list
			pageCount: 1, // For pager
			page: 1, // For pager
			searchPrductTransfer: null
		}
	},

	mounted: async function() {
		if (this.$route.params.page == undefined) {
			this.page = 1
		}

		// Get all
		var data = {
			limit: this.limit,
			populate: ['author']
		}

		const apiGetTransfer = await this.$api.getStockTransfer({ data })
		this.pageCount = Math.ceil(apiGetTransfer.data.total / this.limit)
		this.list = apiGetTransfer.data.list
	},

	methods: {
		piStatus: function(item) {
			if (item.disable) {
				return 'DISABLED'
			}

			return item.status ? 'OPEN' : 'CLOSED'
		},

		// When user entered search
		searchTransfer: async function() {
			// Calculate how many items to skip

			var data = {
				limit: this.limit,
				populate: ['author', 'brand', 'shop']
			}

			if (this.searchPrductTransfer) {
				data.code = this.searchPrductTransfer
			}

			const apiGetTransfer = await this.$api.getStockTransfer({ data })
			this.pageCount = apiGetTransfer.data.total / this.limit
			this.list = apiGetTransfer.data.list
		},

		// When user click on page number
		pagerClick: async function(pageNumber) {
			// Calculate how many items to skip
			var skip

			if (pageNumber == 1) {
				skip = 0
			} else {
				skip = (pageNumber - 1) * this.limit
			}

			var data = {
				limit: this.limit,
				skip,
				populate: ['author', 'brand', 'shop']
			}

			if (this.searchPrductTransfer) {
				data.code = this.searchPrductTransfer
			}

			const apiGetTransfer = await this.$api.getStockTransfer({ data })
			this.pageCount = Math.ceil(apiGetTransfer.data.total / this.limit)
			this.list = apiGetTransfer.data.list
		},

		// Push to detail page
		transferDetail: function(id) {
			// this.$router.push("/po/detail/" + id);
			this.$router.push({ name: 'transferStockDetail', params: { id } })
		},

		// Convert time
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YY hh:mm a')
		}
	}
}
</script>

<style scoped>
.transferList {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 50px;
	grid-gap: 10px;
	padding: 16px 5px 5px;
	font-weight: bold;
	font-size: 14px;
	color: #000;
	border-bottom: 1px solid #eee;
}

.links {
	width: 500px;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-gap: 10px;
}

.first-row {
	margin: 30px auto;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
	grid-gap: 10px;
	text-align: left;
	font-weight: 600;
	font-size: 14px;
}

.second-row {
	margin: auto;
	text-align: left;
	font-weight: bold;
}

.poItemList {
	margin: auto;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
	grid-gap: 10px;
	padding: 20px 5px;
	font-weight: bold;
	font-size: 14px;
	color: #000;
	border-bottom: 1px solid #eee;
}

.remark {
	width: 100%;
	height: 50px;
	border-radius: 4px;
	border: 1px solid #ccc;
	background-color: #fff;
	padding: 5px;
	color: #000;
	font-size: 14px;
	overflow-wrap: break-word;
}

.header {
	color: #aaa;
	font-weight: bold;
	font-size: 14px;
	margin-bottom: 10px;
}

.firstRow .details {
	margin: 10px;
	color: #777;
}

.details span {
	font-size: 12px;
	color: #999;
	font-weight: bold;
}

.po-detail-buttons-wrapper {
	display: grid;
	grid-template-columns: 1fr 1fr;
	margin: auto;
}

.align-left {
	text-align: left;
}

.align-right {
	text-align: right;
}

.qtyInput {
	width: 90px;
	height: 30px;
	border: 0;
	text-align: center;
	border-radius: 5px;
	padding-left: 10px;
	font-size: 14px;
	font-weight: bold;
	color: #000;
	background-color: #f5f5f5;
	/* background: #70a15a; */
}

.priceInput {
	width: 150px;
	height: 30px;
	border: 0;
	text-align: center;
	border-radius: 5px;
	padding-left: 10px;
	font-size: 14px;
	font-weight: bold;
	color: #000;
	background-color: #f5f5f5;
}

.calenderInput {
	width: 150px;
	text-align: center;
	margin: auto;
}

.po .closed {
	height: 40px;
	width: 100px;
	border-radius: 5px;
	padding-top: 10px;
	background: #e25b5b;
	margin: auto;
	color: #fff;
}

.po .opened {
	height: 40px;
	width: 100px;
	border-radius: 5px;
	padding-top: 10px;
	background: #129d7b;
	margin: auto;
	color: #fff;
}
</style>
